





















































































































































import { Importacao } from '@/models'
import { nextTick } from '@/shareds/utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { Vue, Component, Watch, Ref } from 'vue-property-decorator'
import { DataOptions } from 'vuetify'
import { FindImportacaoUseCase } from '@/usecases'
import axios, { AxiosRequestConfig, CancelTokenSource } from 'axios'
import { sortConverter } from '@/shareds/paginacao'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import router from '@/router'
import DialogoItensDeImportacao from './DialogoItensDeImportacao.vue'
import RangeDatePicker from '@/components/ui/RangeDatePicker.vue'
import moment from 'moment'
import { ImportacaoDeNota } from '@/models/ImportacaoDeNota'
import { NotaFiscalService } from '@/services'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import * as LZString from 'lz-string'

@Component({
	components: {
		DialogoItensDeImportacao,
		RangeDatePicker,
	},
})
export default class TelaDeImportacoes extends Vue {
	importacoes: Importacao[] = []
	@Ref() dialogoImportacao!: DialogoItensDeImportacao

	findUseCase = new FindImportacaoUseCase
	notaFiscalService = new NotaFiscalService
	findImportacaoUseCase = new FindImportacaoUseCase

	filtro = {
		tipoDeProcesso: [],
		origem: [],
		status: [],
		datas: [],
		horas: [null, null],	
	}
	cancelToken: CancelTokenSource | null = null
	totalDeRegistros = -1
	buscando = false
	carregandoItemDeImportacao: Record<string, boolean> = {}
	importacaoDeNota: ImportacaoDeNota | null = (() => {
		try {
			const raw = localStorage.getItem('IMPORTACAO_DE_NOTA')
			if (!raw) return null
			const json = LZString.decompress(raw)
			if (!json) return null
			return JSON.parse(json)
		} catch {
			return null
		}
	})()

	headers = [
		{ text: 'Tipo de Processo', value: 'tipoDeProcesso'},
		{ text: 'Processo', value: 'origem' },
		{ text: 'Status', value: 'status' },
		{ text: 'Progresso', value: 'progressoPercentual' },
		{ text: 'Iniciado em', value: 'createdAt' },
		{ text: 'Quantidade (itens)', value: 'totalItens' },
		{ text: 'Ações', value: 'actions', 	sortable: false},
	]

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	get itensFormatados() {
		return this.importacoes.map(importacao => {
			let itemDeImportacao: any = null
			if (importacao.origem === 'Entrada De Nota' && importacao.itens.length > 0 && !!importacao.itens[0]) {
				itemDeImportacao = JSON.parse(importacao.itens[0].item)
			}
			return ({
				...importacao,
				createdAt: !importacao.createdAt ? '-' : dateTimeToPtBrFormat(importacao.createdAt),
				origem: itemDeImportacao ? importacao.origem + ' - Loja: ' + itemDeImportacao.lojaDestinoDaImportacao.nomeFantasia + ' - NF/Serie: '
					+ itemDeImportacao.chNfe.substring(25,34) + '/' + itemDeImportacao.chNfe.substring(22,25)
					:
					importacao.origem,
			})
		})
	}

	statusColor(status: string) {
		if(status === 'Concluído' || status === 'Exportação') return 'success--text font-weight-bold'
		if(status === 'Em Andamento') return 'info--text font-weight-bold'
		if(status === 'Pendente' || status ==='Atualização') return 'warning--text font-weight-bold'
		if(status === 'Incompleto' || status === 'Importação') return 'error--text font-weight-bold'
	}

	returnMessage(origem: string) {
		if(origem == 'Tabela De Preço') return 'Ir para a Tabela De Preço'
		if(origem == 'Estoque') return 'Ir para Tela de Estoque'
		if(origem == 'Cliente') return 'Ir para a Tela de Clientes'
	}

	irPara(origem: string, idOrigem: string) {
		if(origem == 'Tabela De Preço') {
			router.push({
				path: `precos/${idOrigem}`,
			})
		}else if(origem == 'Estoque'){
			router.push({
				path: `estoques?l=${idOrigem}`,
			})
		} else if(origem == 'Cliente') {
			router.push({
				path: `/clientes`,
			})
		}
	}

	get idLoja() {
		return this.$route.query.l as string
	}

	gerarDataHora(data?: string | null, hora?: string | null): string | undefined {
		return moment(`${data} ${hora}`,  'YYYY-MM-DD HH:mm').toISOString(true)
	}

	async buscar() {
		if (this.cancelToken) this.cancelToken.cancel()
		await nextTick()
		try {
			this.buscando = true
			this.cancelToken = axios.CancelToken.source()
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			const sorted = sortConverter(this.paginacao)

			if(this.isReverseData()) {
				this.filtro.datas.reverse()
			}
			const dataHoraInicial = this.gerarDataHora(this.filtro.datas[0], this.filtro.horas[0] || '00:00')
			const dataHoraFinal = this.gerarDataHora(this.filtro.datas[1], this.filtro.horas[1] || '23:59')

			const filtrosFormatados = {
				tipoDeProcesso: this.filtro.tipoDeProcesso,
				origem: this.filtro.origem,
				status: this.filtro.status,
				dataInicial: dataHoraInicial ? dataHoraInicial : undefined,
				dataFinal: dataHoraFinal ? dataHoraFinal : undefined,
			}
			
			const page = await this.findUseCase.find(
				{
					...filtrosFormatados,
					sort: !sorted.length ? "createdAt,DESC" : [...sorted],
					page: this.paginacao.page - 1 || 0,
					size: this.paginacao.itemsPerPage,
				},
				axiosConfig)
			this.importacoes = page.content
			this.totalDeRegistros = page.totalElements

		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.buscando = false
		}
	}

	isReverseData() {
		if(!this.filtro.datas[0] || !this.filtro.datas[1]) return false
		if(this.filtro.datas[1] < this.filtro.datas[0]) return true
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao = this.buscar

	async baixarXmls(idImportacao: string) {
		try {
			const axiosConfig: AxiosRequestConfig = {
				responseType: 'blob',
			}

			const response = await this.findUseCase.baixarXmls(idImportacao, axiosConfig)

			const blob = new Blob([response], { type: 'application/zip' });
			const fileName = `XMLS_${new Date().getTime()}.zip` 
			this.downloadBlob(blob, fileName);
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	downloadBlob(blob, filename) {
		const url = URL.createObjectURL(blob);

		const a = document.createElement('a');
		a.href = url;
		a.download = filename;

		document.body.appendChild(a);
		a.click();

		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	}	

	@Watch("importacoes")
	mostrarBotao(item) {
		return item.status === 'Concluído' && item.origem === 'Download de Xmls Completos';
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	async reabrirImportacaoDeNota(item: Importacao){
		try{
			this.$set(this.carregandoItemDeImportacao, item.id, true)

			const params = {
				importacaoId: item.id,
				pageable: null,
			}

			const itemDeImportacao = await this.findUseCase.findItens(params);

			const json = itemDeImportacao.content[0].item
			const comprimido = LZString.compress(json)
			localStorage.setItem('IMPORTACAO_DE_NOTA', comprimido)

			this.importacaoDeNota = JSON.parse(json)

			if(!this.permiteAbrirDiversosProcessosDeImportacao){
				const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(UserLoginStore.usuario?.id || '');

				if(!possuiProcessoEmAberto){
					AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
					this.$set(this.carregandoItemDeImportacao, item.id, false)
					return
				}
			}

			if(this.importacaoDeNota && this.importacaoDeNota.chNfe !== null){
				const nota = await this.notaFiscalService.findNotaByChNFe(this.importacaoDeNota.chNfe)
				if(nota){
					AlertModule.setError('Nota já importada!')
					this.$set(this.carregandoItemDeImportacao, item.id, false)
					return
				}
			}

			this.$set(this.carregandoItemDeImportacao, item.id, false)
			this.$router.push('/importacao-de-notas-antiga')

		} catch (error: any) {
			AlertModule.setError(error)
		}
		
	}
}
